// Purpose: Keep the browser's screenplay reading-size preference safe and consistent.

export const SCREENPLAY_TEXT_SIZES = ["small", "medium", "large"] as const;

export type ScreenplayTextSize = (typeof SCREENPLAY_TEXT_SIZES)[number];

export const DEFAULT_SCREENPLAY_TEXT_SIZE: ScreenplayTextSize = "medium";

export const parseScreenplayTextSize = (
  value: unknown,
): ScreenplayTextSize =>
  typeof value === "string" &&
  SCREENPLAY_TEXT_SIZES.includes(value as ScreenplayTextSize)
    ? (value as ScreenplayTextSize)
    : DEFAULT_SCREENPLAY_TEXT_SIZE;

export const screenplayTextSizeClass = (
  size: ScreenplayTextSize,
): string => {
  if (size === "small") return "text-xs leading-4";
  if (size === "large") return "text-base leading-6";
  return "text-sm leading-5";
};
